import { filterClientsByQuery as e } from "../helpers/filter-clients-by-query.js";
import { findClient as t } from "../helpers/find-client.js";
import { operationToHar as n } from "../helpers/operation-to-har/operation-to-har.js";
import { generateCodeSnippet as ee } from "../helpers/generate-code-snippet.js";
import { getCustomCodeSamples as te } from "../helpers/get-custom-code-samples.js";
import { getClients as r } from "../helpers/get-clients.js";
import { getSecrets as i } from "../helpers/get-secrets.js";
import ne from "./ExamplePicker.vue.js";
import a from "./HttpMethod.vue.js";
import { Fragment as o, computed as s, createBlock as c, createCommentVNode as l, createElementBlock as u, createElementVNode as d, createSlots as re, createTextVNode as f, createVNode as p, defineComponent as m, onBeforeMount as ie, openBlock as h, ref as g, renderSlot as _, toDisplayString as v, unref as y, useId as b, watch as x, watchEffect as S, withCtx as C } from "vue";
import { ScalarButton as w } from "@scalar/components/button";
import { ScalarCard as T, ScalarCardFooter as ae, ScalarCardHeader as oe, ScalarCardSection as E } from "@scalar/components/card";
import { ScalarCodeBlock as se } from "@scalar/components/code-block";
import { ScalarCombobox as ce } from "@scalar/components/combobox";
import { ScalarVirtualText as le } from "@scalar/components/virtual-text";
import { freezeElement as D } from "@scalar/helpers/dom/freeze-element";
import { ScalarIconCaretDown as O } from "@scalar/icons";
import { getResolvedRef as k } from "@scalar/workspace-store/helpers/get-resolved-ref";
import { getOperationExamples as A, resolveOperationExamples as j } from "@scalar/workspace-store/helpers/operation-examples";
import { useExampleVisibility as M, useExternalExamples as N } from "@scalar/workspace-store/helpers/use-external-examples";
//#region src/code-example/components/CodeExample.vue?vue&type=script&setup=true&lang.ts
var P = ["innerHTML"], F = {
	key: 1,
	class: "text-c-2 flex h-full w-fit items-center px-0.5 py-0 text-base font-normal",
	"data-testid": "client-picker"
}, I = {
	key: 0,
	class: "text-c-2 p-4",
	role: "status"
}, L = ["id"], R = {
	key: 0,
	class: "request-card-footer-addon"
}, z = { class: "request-header" }, B = /*@__PURE__*/ m({
	__name: "CodeExample",
	props: {
		integration: {},
		clientOptions: {},
		selectedClient: {},
		selectedServer: { default: null },
		selectedContentType: {},
		selectedExample: {},
		eventBus: {},
		securitySchemes: { default: () => [] },
		method: {},
		path: {},
		operation: {},
		fallback: { type: Boolean },
		generateLabel: { type: Function },
		isWebhook: { type: Boolean },
		globalCookies: {},
		requestBodyCompositionSelection: {}
	},
	emits: ["update:exampleKey"],
	setup(m, { emit: B }) {
		let V = B, H = s(() => {
			let e = k(m.operation.requestBody)?.content ?? {}, t = m.selectedContentType || Object.keys(e)[0];
			return t ? e[t]?.examples ?? {} : {};
		}), U = g(""), W = (e) => {
			let t = Object.keys(H.value);
			return e && t.includes(e) ? e : U.value && t.includes(U.value) ? U.value : t[0] ?? "";
		};
		ie(() => {
			U.value = W(m.selectedExample);
		}), x(() => m.selectedExample, (e) => {
			U.value = W(e);
		}), x(() => m.selectedContentType, () => {
			Object.keys(H.value).includes(U.value) || (U.value = W(m.selectedExample));
		}), S(() => {
			V("update:exampleKey", U.value);
		});
		let ue = (e) => {
			U.value = e, m.eventBus.emit("workspace:update:selected-example", e);
		}, G = s(() => te(m.operation)), K = s(() => r(G.value.samples, m.clientOptions, G.value.label)), q = s(() => K.value.reduce((e, t) => e + t.options.length, 0)), J = g(t(K.value, m.selectedClient));
		x([() => m.selectedClient, K], ([e]) => {
			let n = t(K.value, e);
			n && (J.value = n);
		});
		let Y = g(null), de = M(Y), X = N(() => A(m.operation, U.value, m.selectedContentType), () => de.value), Z = s(() => j(m.operation, U.value, m.selectedContentType, X.resolve)), Q = s(() => {
			if (!m.isWebhook) return null;
			try {
				return n({
					operation: Z.value,
					method: m.method,
					path: m.path,
					example: U.value,
					requestBodyCompositionSelection: m.requestBodyCompositionSelection,
					defaultDisabledParameters: !0
				});
			} catch (e) {
				return console.error("[webhookHar]", e), null;
			}
		}), $ = s(() => m.isWebhook ? Q.value?.postData?.text ?? "" : ee({
			defaultDisabledParameters: !0,
			includeDefaultHeaders: m.integration === "client",
			clientId: J.value?.id,
			customCodeSamples: G.value.samples,
			operation: Z.value,
			method: m.method,
			path: m.path,
			contentType: m.selectedContentType,
			server: m.selectedServer,
			securitySchemes: m.securitySchemes,
			example: U.value,
			globalCookies: m.globalCookies,
			requestBodyCompositionSelection: m.requestBodyCompositionSelection
		})), fe = s(() => m.isWebhook ? pe.value : J.value?.lang), pe = s(() => {
			if (!Q.value?.postData) return "json";
			let e = Q.value.postData.mimeType;
			return e?.includes("json") ? "json" : e?.includes("xml") ? "xml" : e?.includes("yaml") || e?.includes("yml") ? "yaml" : e?.includes("text/plain") ? "text" : "json";
		}), me = s(() => i(m.securitySchemes)), he = (e) => {
			if (Y.value) {
				let e = D(Y.value.$el);
				setTimeout(() => {
					e();
				}, 300);
			}
			J.value = e, e && m.eventBus.emit("workspace:update:selected-client", e.id);
		}, ge = s(() => ($.value.length ?? 0) > 2e4), _e = b();
		return (t, n) => $.value || y(X).pending.value ? (h(), c(y(T), {
			key: 0,
			ref_key: "elem",
			ref: Y,
			class: "request-card dark-mode"
		}, {
			default: C(() => [
				p(y(oe), { class: "pr-2.5" }, re({
					default: C(() => [
						n[1] ||= d("span", { class: "sr-only" }, "Request Example for", -1),
						p(a, {
							as: "span",
							class: "request-method",
							method: m.method
						}, null, 8, ["method"]),
						m.generateLabel ? (h(), u("span", {
							key: 0,
							innerHTML: m.generateLabel()
						}, null, 8, P)) : l("", !0),
						_(t.$slots, "header", {}, void 0, !0)
					]),
					_: 2
				}, [!m.isWebhook && q.value ? {
					name: "actions",
					fn: C(() => [q.value > 1 ? (h(), c(y(ce), {
						key: 0,
						class: "max-h-80",
						filterFn: y(e),
						modelValue: J.value,
						options: K.value,
						placement: "bottom-end",
						teleport: "",
						"onUpdate:modelValue": n[0] ||= (e) => he(e)
					}, {
						default: C(() => [p(y(w), {
							class: "text-c-2 hover:text-c-1 flex h-full w-fit gap-1.5 px-0.5 py-0 text-base font-normal",
							"data-testid": "client-picker",
							variant: "ghost"
						}, {
							default: C(() => [f(v(J.value?.title) + " ", 1), p(y(O), {
								class: "ui-open:rotate-180 mt-px size-3 transition-transform duration-100",
								weight: "bold"
							})]),
							_: 1
						})]),
						_: 1
					}, 8, [
						"filterFn",
						"modelValue",
						"options"
					])) : (h(), u("span", F, v(J.value?.title), 1))]),
					key: "0"
				} : void 0]), 1024),
				p(y(E), { class: "request-editor-section custom-scroll p-0" }, {
					default: C(() => [y(X).pending.value ? (h(), u("div", I, [y(X).failed.value ? (h(), u(o, { key: 0 }, [n[3] ||= f(" Could not load this example. ", -1), p(y(w), {
						size: "sm",
						variant: "ghost",
						onClick: y(X).retry
					}, {
						default: C(() => [...n[2] ||= [f(" Retry ", -1)]]),
						_: 1
					}, 8, ["onClick"])], 64)) : (h(), u(o, { key: 1 }, [f("Loading example…")], 64))])) : (h(), u("div", {
						key: 1,
						id: `${y(_e)}-example`,
						class: "code-snippet"
					}, [ge.value ? (h(), c(y(le), {
						key: 1,
						containerClass: "custom-scroll scalar-code-block border rounded-b flex flex-1 max-h-screen",
						contentClass: "language-plaintext whitespace-pre font-code text-base p-2",
						lineHeight: 20,
						text: $.value
					}, null, 8, ["text"])) : (h(), c(y(se), {
						key: 0,
						class: "bg-b-2 h-full",
						content: $.value,
						hideCredentials: me.value,
						lang: fe.value,
						lineNumbers: ""
					}, null, 8, [
						"content",
						"hideCredentials",
						"lang"
					]))], 8, L))]),
					_: 1
				}),
				Object.keys(H.value).length > 1 || t.$slots.footer ? (h(), c(y(ae), {
					key: 0,
					class: "request-card-footer bg-b-3"
				}, {
					default: C(() => [Object.keys(H.value).length > 1 ? (h(), u("div", R, [Object.keys(H.value).length ? (h(), c(ne, {
						key: 0,
						examples: H.value,
						modelValue: U.value,
						"onUpdate:modelValue": ue
					}, null, 8, ["examples", "modelValue"])) : l("", !0)])) : l("", !0), _(t.$slots, "footer", { exampleName: U.value }, void 0, !0)]),
					_: 3
				})) : l("", !0)
			]),
			_: 3
		}, 512)) : m.fallback ? (h(), c(y(T), {
			key: 1,
			class: "request-card dark-mode"
		}, {
			default: C(() => [p(y(E), { class: "request-card-simple" }, {
				default: C(() => [d("div", z, [p(a, {
					as: "span",
					class: "request-method",
					method: m.method
				}, null, 8, ["method"]), _(t.$slots, "header", {}, void 0, !0)]), _(t.$slots, "footer", { exampleName: U.value }, void 0, !0)]),
				_: 3
			})]),
			_: 3
		})) : l("", !0);
	}
});
//#endregion
export { B as default };

//# sourceMappingURL=CodeExample.vue.script.js.map